export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background flex flex-col" id="privacy">
      <main className="py-16 px-6 flex-grow">
        <div className="container max-w-4xl mx-auto prose prose-blue">
          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
          <p className="text-muted-foreground mb-4">Last updated: Feb 04, 2025</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
            <p>
              Welcome to AquaMind AI (“we,” “us,” or “our”). We value your privacy and are committed to protecting your personal information.
              This Privacy Policy explains what information we collect, how we use it, and the steps we take to safeguard it.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
            <ul className="list-disc pl-6">
              <li><strong>Contact Information:</strong> When you fill out our “Contact Us” form, we collect your name, email address, and any other details you choose to provide.</li>
              <li><strong>No Cookies:</strong> We do not currently use cookies or similar technologies on our website.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6">
              <li><strong>Respond to Inquiries:</strong> We use the information you provide to respond to your questions, discuss potential opportunities, and deliver our services.</li>
              <li><strong>Internal Operations:</strong> We may use your information for internal analysis and improvements to our website or offerings.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Data Sharing and Disclosure</h2>
            <p>We do not sell, rent, or trade your personal information to third parties. We may share your information only if required by law or to protect our rights and property.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Data Security</h2>
            <p>We use standard security measures to help protect your personal information from unauthorized access. Despite our efforts, no method of electronic transmission or storage is completely secure, and we cannot guarantee absolute security.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Your Choices</h2>
            <ul className="list-disc pl-6">
              <li><strong>Update or Delete:</strong> You can contact us at any time to update or request deletion of your personal information.</li>
              <li><strong>Opt-Out:</strong> If you no longer wish to receive communications from us, please let us know.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will post any changes on this page with a new “Last Updated” date.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
            <p>Email: <a href="mailto:privacy@aquamindai.com" className="text-blue-600">privacy@aquamindai.com</a></p>
          </section>
        </div>
      </main>
    </div>
  );
}